import { render } from "./UsersIndex.vue?vue&type=template&id=6c79d962&scoped=true"
import script from "./UsersIndex.vue?vue&type=script&lang=js"
export * from "./UsersIndex.vue?vue&type=script&lang=js"

import "./UsersIndex.vue?vue&type=style&index=0&id=6c79d962&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c79d962"]])

export default __exports__